export default __webpack_public_path__ + "static/streamlining-sea-route-booking-with-an-iIntegrated-online-platform-fbd3a433a8e045b9abde2f5d07c3e35d.png";